import React, { useState, useEffect } from "react";
import { Card, CardTitle, CardBody } from "reactstrap";
import SingleSuperUserNotification from "./SingleSuperUserNotification";
import Pacmanloader from "../Pacmanloader/Pacmanloader";
import { fetchNotifications } from "../../actions/notificationActions";
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";

export default function AdminNotificationsShow({ schoolData, licenseData }) {
  const [notificationData, setNotificationData] = useState([]);
  const dispatch = useDispatch();

  const notifications = useSelector((state) => state.notificationsReducer);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  useEffect(() => {
    if (!notifications.loading) {
      let tempNotifications = [...notifications.notifications];
      tempNotifications = tempNotifications.filter(
        (noti) => !noti.notice.isDeleted
      );
      tempNotifications = tempNotifications.sort(function (o1, o2) {
        return new Date(o2.notice.created) - new Date(o1.notice.created);
      });
      setNotificationData(tempNotifications);
    }
  }, [notifications.loading, notifications.notifications]);

  if (notifications.loading) {
    return <Pacmanloader />;
  }

  return (
    <Card>
      <CardBody>
        <CardTitle>
          <FormattedMessage id="Navigation_Notifications" />
        </CardTitle>
        {notificationData.map((notification) => {
          return (
            <SingleSuperUserNotification
              key={notification.notice.id}
              notification={notification}
              schoolData={schoolData}
              licenseData={licenseData}
            />
          );
        })}
      </CardBody>
    </Card>
  );
}
